'use client';

import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

function resolveColor(value: string | undefined): string | undefined {
  if (!value || typeof window === 'undefined' || !value.includes('var(')) {
    return value;
  }

  const probe = document.createElement('span');
  probe.style.color = value;
  document.body.appendChild(probe);
  const resolved = getComputedStyle(probe).color;
  probe.remove();

  // qrcode only accepts hex; convert rgb(...) / rgba(...) → #rrggbb
  const m = (resolved || value).match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (m) {
    return '#' + [m[1], m[2], m[3]].map(n => parseInt(n).toString(16).padStart(2, '0')).join('');
  }

  return resolved || value;
}

export function useQrDataUrl(
  token: string | null,
  options?: { dark?: string; light?: string; size?: number },
): string | null {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    let active = true;
    const dark = resolveColor(options?.dark ?? 'var(--text)');
    const light = resolveColor(options?.light ?? 'var(--surface)');

    QRCode.toDataURL(token, {
      width: options?.size ?? 240,
      margin: 1,
      color: {
        dark,
        light,
      },
      errorCorrectionLevel: 'M',
    })
      .then((nextDataUrl) => {
        if (active) setDataUrl(nextDataUrl);
      })
      .catch(() => {
        if (active) setDataUrl(null);
      });

    return () => {
      active = false;
    };
  }, [token, options?.dark, options?.light, options?.size]);

  return token ? dataUrl : null;
}
